var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"hoc-preview-email-button fz-12"},[_vm._v("\n    "+_vm._s(_vm.btnAddText)+" "),_c('i',{staticClass:"fal fa-paper-plane"})])}
var staticRenderFns = []

export { render, staticRenderFns }